/**
 * Authenticated API client helper
 *
 * Wraps fetch() with automatic Authorization: Bearer <idToken> header
 * when the user is signed in. Falls back to unauthenticated for public
 * endpoints (assessment page, diagnostic).
 *
 * Usage:
 *   import { apiFetch } from '../lib/apiClient'
 *   const data = await apiFetch('/dashboard/runs', idToken)
 */

const API_BASE = import.meta.env.VITE_API_URL
  || 'https://clutch-ocm-scorer-uqrk7imnlq-uc.a.run.app'

export async function apiFetch<T = unknown>(
  path: string,
  idToken: string | null,
  options?: RequestInit,
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options?.headers as Record<string, string> ?? {}),
  }

  if (idToken) {
    headers['Authorization'] = `Bearer ${idToken}`
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  })

  if (!res.ok) {
    throw new Error(`API error ${res.status}: ${await res.text()}`)
  }

  return res.json()
}
